export const pagesIdManagementsEn = {
  groupId: {
    add: {
      completeDialog: {
        completeLinkButton: 'Go to ID Details',
        message: 'ID has been added successfully.',
      },
      form: {
        fields: {
          effectiveFrom: {
            label: 'Effective from',
          },
          effectiveTo: {
            label: 'Effective to',
          },
          loginId: {
            label: 'Group ID',
            placeholder: 'Type ID',
          },
          name: {
            label: 'Group ID Name',
            placeholder: 'Enter Group ID name',
          },
          owner: {
            label: 'Owner',
          },
          usagePurpose: {
            label: 'Usage/Purpose',
            placeholder: 'Enter usage purpose',
          },
        },
        result: {
          addedLabel: 'Added Group ID:',
          completedBy: 'Completed by',
          continueAdding: 'Continue adding another group ID',
          goToDetail: 'Go to detail',
          successMessage: 'Group ID has been successfully added.',
          title: 'Result',
        },
        sections: {
          groupIdInformation: 'Group ID information',
          operationStatus: 'Operation & Status',
          ownershipAccountability: 'Ownership & Accountability',
        },
        stepTitle: 'Group ID information',
        submitButtonLabel: 'Add Group ID',
        validationError: {
          requiredFieldsMissing:
            'Please fill in the required fields in the Group ID Information step.',
        },
      },
      intro: {
        fillOutDetails: 'Fill out the details',
        header: {
          description: 'description',
          title: 'Add group ID data',
        },
        methods: {
          fromExisting: {
            required: {
              groupId: 'Group ID',
              groupName: 'Group ID name',
              software: 'Software',
            },
            title: 'Add from the existing user account’s ID in a software',
          },
          fromScratch: {
            required: {
              groupId: 'Group ID',
              groupName: 'Group ID name',
            },
            title: 'Add from scratch',
          },
          requiredDetails: 'Required details:',
        },
        options: {
          bulkCsvUpload: {
            title: 'Bulk add by uploading a csv file',
          },
          description: 'Or you might want to...',
        },
        selectHowToAdd: 'Select how to add:',
      },
      step1: {
        loginIdLabel: 'Login ID',
        loginIdPlaceholder: 'Enter Login ID',
        nameLabel: 'Name',
        namePlaceholder: 'Enter Name',
        ownerLabel: 'Owner',
        submitButtonLabel: 'Submit',
        title: 'Basic Information',
      },
      title: 'Add Group ID',
    },
    detail: {
      changePeopleGroup: 'Change People Group',
      createPeopleGroupIfNotExists:
        'If there is no necessary People Group, create one.',
      edit: 'Edit Conditions',
      needToSelectPeopleGroup:
        'Select a People Group to assign members to the Group ID',
      selectPeopleGroup: 'Select People Group',
      toPeopleGroup: 'Open People Group',
    },
    details: {
      detail: {
        dialogs: {
          changeOwner: {
            cancelButtonLabel: 'Cancel',
            confirmButtonLabel: 'Save',
            description:
              'Select a person to assign as the owner of this Group ID.',
            editLabel: 'Edit',
            fromLabel: 'From',
            selectLabel: 'Select Owner',
            title: 'Change Owner',
            toLabel: 'To',
          },
          unassignOwner: {
            cancelButtonLabel: 'Cancel',
            confirmButtonLabel: 'Unassign',
            description:
              'Are you sure you want to unassign {{ownerName}} as the owner?',
            title: 'Unassign Owner',
          },
        },
        sections: {
          groupIdInformation: {
            comingSoon: 'Coming soon',
            groupId: 'Group ID',
            groupIdName: 'Group ID Name',
            groupIdNamePlaceholder: 'Enter Group ID name',
            groupIdNameUpdateSuccess: 'Group ID Name updated successfully',
            loginIdRequired: 'Group ID is required',
            title: 'Group ID information',
            updateSuccess: 'Group ID updated successfully',
            usagePurpose: 'Usage/Purpose',
            usagePurposePlaceholder: 'Enter usage/purpose',
            usagePurposeUpdateSuccess: 'Usage/Purpose updated successfully',
          },
          operationStatus: {
            comingSoon: 'Coming soon',
            effectiveFrom: 'Effective from',
            effectiveTo: 'Effective to',
            title: 'Operation & Status',
            updateError: 'Failed to update operation status',
            updateSuccess: 'Operation status updated successfully',
            validationError: {
              effectiveFromAfterTo:
                'Effective from date must be before effective to date',
            },
          },
          ownershipAccountability: {
            assignOwner: 'Assign Owner',
            changeOwner: 'Change',
            noOwner: 'No owner assigned',
            owner: 'Owner',
            title: 'Ownership & Accountability',
            unassignSuccess: 'Owner unassigned successfully',
            updateError: 'Failed to update owner',
            updateSuccess: 'Owner updated successfully',
          },
        },
      },
      members: {
        actions: {
          assignPerson: 'Assign person',
          openMenu: 'Open menu',
          unassign: 'Unassign',
        },
        columns: {
          organization: 'Organization',
          position: 'Position',
        },
        dialogs: {
          assignPerson: {
            closeButtonLabel: 'Close',
            confirmButtonLabel: 'Assign',
            description: 'Select a person to assign to this Group ID.',
            selectLabel: 'Select person',
            title: 'Assign person',
          },
          unassignPerson: {
            cancelButtonLabel: 'Cancel',
            confirmButtonLabel: 'Unassign',
            description: 'Are you sure you want to unassign {{personName}}?',
            title: 'Unassigning person',
          },
        },
        filterPlaceholder: 'Filter by name, email...',
        tabs: {
          all: 'All',
          alumni: 'Alumni',
          following: 'Following',
          violatedAssignment: 'Violated assignment',
        },
        toasts: {
          assignSuccess: 'Person assigned successfully',
          error: 'Failed to update members',
          unassignSuccess: 'Person unassigned successfully',
        },
      },
      ruleAndPolicy: {
        actions: {
          addRule: 'Add people group',
          addRuleButton: 'Add rule',
          removeRule: 'Remove',
        },
        empty: {
          description:
            'Add People Groups to automatically assign members to this Group ID.',
          title: 'No assignment rules configured',
        },
        groupIdLabel: 'Group ID',
        infoMessage:
          'Members of selected People Groups are assigned to this Group ID. Manual assignments remain.',
        noDescription: 'No description',
        tableOfContent: {
          title: 'Assignment rules',
        },
      },
      tabs: {
        detail: 'Detail',
        devices: 'Devices',
        members: 'Members',
        people: 'People',
        ruleAndPolicy: 'Rule & Policy',
        securityAndAuth: 'Sec. & Auth.',
        softwares: 'Softwares',
      },
    },
    ledger: {
      actions: {
        delete: 'Delete',
        openMenu: 'Open menu',
      },
      deleteDialog: {
        cancelButton: 'Cancel',
        confirmButton: 'Delete',
        description: 'Are you sure you want to delete {{groupId}}?',
        successToast: 'Group ID deleted successfully',
        title: 'Delete Group ID',
        warning: 'This action cannot be undone.',
      },
      filterPlaceholder: 'Filter by ID, name...',
    },
  },
  list: {
    addId: 'Add ID',
    columns: {
      appName: 'App',
      id: 'ID',
      personName: 'Name',
    },
    filterPlaceholder: 'Search by ID, name, email, etc.',
    pageTitle: 'IDs',
    tabs: {
      all: 'All',
      boardMemberId: 'Board Member ID',
      collaboratorId: 'Collaborator ID',
      contactId: 'Contact',
      contractorId: 'Contractor ID',
      employeeId: 'Employee ID',
      groupId: 'Group ID',
      itServiceId: 'IT Service',
      personalId: 'Personal ID',
      snsId: 'SNS',
      unknownId: 'Unknown ID',
    },
    unknownIdsActionsColumn: {
      createGroupId: 'Transform to  Group ID',
    },
  },
  people: {
    filterPlaceholder: 'Search by name, id, email...',
    matchType: {
      assignmentRule: 'Assignment Rule',
      employeeId: 'Employee ID',
      employeeNumber: 'Employee Number',
      employeeSubId: 'Employee Sub ID',
      manualAssign: 'Manual Assign',
      personalEmail: 'Personal Email',
      personalMainEmail: 'Personal Main Email',
      personalPhone: 'Personal Phone',
      personalSnsId: 'SNS ID',
      personalSubEmail: 'Personal Sub Email',
      workerEmail: 'Work Email',
      workerMainEmail: 'Work Main Email',
      workerMainPhone: 'Work Main Phone',
      workerSubEmail: 'Work Sub Email',
      workerSubPhone: 'Work Sub Phone',
    },
    pageTitle: 'People',
    tabs: {
      all: 'All',
      boardMember: 'Board',
      collaborator: 'Collaborator',
      contractor: 'Contractor',
      employee: 'Employee',
    },
  },
};
